import { useTRPC } from "../../../../trpc/client";
import { useMutation } from "@tanstack/react-query";

export function useEditCreateInvoice(
  onSuccessCallback: () => void,
  onErrorCallback: (error: unknown) => void
) {
  const trpc = useTRPC();
  const mutation = useMutation(trpc.invoices.create.mutationOptions());

  return async (data: Parameters<typeof mutation.mutateAsync>[0]) => {
    try {
      await mutation.mutateAsync(data);
      onSuccessCallback();
    } catch (error) {
      console.error("Invoice creation error:", error);
      onErrorCallback(error);
    }
  };
}
